import { AlertTriangle, RefreshCw } from 'lucide-react';

export function StatusPanel({
  title,
  message,
  action,
}: {
  title: string;
  message: string;
  action?: () => void;
}) {
  return (
    <section className="status-panel" role="status">
      <AlertTriangle aria-hidden="true" />
      <div>
        <h2>{title}</h2>
        <p>{message}</p>
      </div>
      {action && (
        <button className="button secondary" onClick={action}>
          <RefreshCw size={18} />
          Try again
        </button>
      )}
    </section>
  );
}

export function LoadingTopics() {
  return (
    <div className="skeleton-list" aria-label="Loading topics" aria-busy="true">
      {[0, 1, 2].map((item) => (
        <div className="skeleton-row" key={item}>
          <span />
          <span />
          <span />
        </div>
      ))}
    </div>
  );
}
